import { DiceWidget } from "assets/icons";
import { DropdownSetting, InformationSetting, RememberSettings } from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { DiceRoller, InteractiveDiceState } from "./DiceRoller";
import { DiceTypeSettings } from "./DiceTypeSettings";

export const InteractiveDiceWidget: WidgetType<InteractiveDiceState> = {
  name: "Dice",
  component: DiceRoller,
  icon: DiceWidget,
  showOnToolbar: true,
  sizing: {
    minWidth: 85,
    minHeight: 118,
    minAspectRatio: 0.8,
    maxAspectRatio: 0.8,
  },
  defaultState: {
    diceRolls: [6],
  },
  defaultSize: {
    aspectRatio: 0.8,
    widthPercentage: 16,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Rolls 1-5 dice with each button press.<br /><br />Configure how many sides are on each dice and how many dice to roll.",
      },
    },
    config: {
      editor: DiceTypeSettings,
      info: {},
      defaultValue: "standard",
    },
    count: {
      editor: DropdownSetting,
      info: {
        name: "Number of Dice",
        options: ["1", "2", "3", "4", "5"],
      },
      defaultValue: "1",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.dice,
        widgetDisplayName: "Dice",
      },
    },
  },
};
